var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M14 2V0H0V14H2V16H16V2H14ZM13 13H1V1H13V13Z","fill":"#939C9D"}})
}
var staticRenderFns = []

export { render, staticRenderFns }